<div class="select-checkeable" [class.select-checkeable--disabled]="disabled">
    <span class="select-checkeable__label">{{ label }}</span>
    <div class="select-checkeable__placeholder" (click)="!disabled && (isOpen = !isOpen)">
        {{ getDisplayText() }}
        <img
            [src]="isOpen ? '/assets/icons/arrow-up.svg' : '/assets/icons/arrow-down.svg'"
            alt="Arrow"
            (click)="clearFilter()"
        />
    </div>
    <div *ngIf="isOpen" class="select-checkeable__menu">
        <div *ngIf="options.length; else noOptionsElement">
            <div class="select-checkeable__search">
                <img src="/assets/icons/zoom.svg" alt="Search icon" />
                <input
                    placeholder="Search {{ label }}"
                    [(ngModel)]="filterValue"
                    [ngModelOptions]="{ standalone: true }"
                />
                <img
                    src="/assets/icons/remove-icon.svg"
                    alt="Remove icon"
                    (click)="clearFilter()"
                />
            </div>
            <div class="select-checkeable__options">
                <div (click)="toggleAll()">
                    <img
                        *ngIf="selectedOptions.length === 0"
                        src="/assets/icons/checkbox.svg"
                        alt=""
                    />
                    <img
                        *ngIf="
                    selectedOptions.length &&
                    selectedOptions.length &lt; options.length
                  "
                        src="/assets/icons/checkbox-partial.svg"
                        alt=""
                    />
                    <img
                        *ngIf="selectedOptions.length === options.length"
                        src="/assets/icons/checkbox-checked.svg"
                        alt=""
                    />
                    <span
                        >Select All
                        {{ (options | stringListFilter: filterValue).length }}
                        Clients</span
                    >
                </div>
                <hr />
                <div
                    *ngFor="let client of options | stringListFilter: filterValue"
                    (click)="toggle(client)"
                >
                    <img
                        *ngIf="!selectedOptions.includes(client)"
                        src="/assets/icons/checkbox.svg"
                        alt=""
                    />
                    <img
                        *ngIf="selectedOptions.includes(client)"
                        src="/assets/icons/checkbox-checked.svg"
                        alt=""
                    />
                    <span>{{ client }}</span>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #noOptionsElement>
    <span class="no-options">No options found</span>
</ng-template>
